import React from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import useIsAr from "../../../../Hooks/useIsAr";
import { REQUEST_STATUSES } from "../../../../configs/enums";
import {
  formatDate,
  getUnitOfMeasure,
  getStatusKPIName,
} from "../../../../helpers";

import Table from "../../../NewTable";

import "./style.scss";

function History({ data }) {
  const [isAr, locale] = useIsAr();
  const requestStatuses = useSelector(
    ({ theme }) => theme.WorkflowStatus.item.Items
  );

  function getStyle(status) {
    if (status === REQUEST_STATUSES.SUBMITTED) return "is-active";
    if (status === REQUEST_STATUSES.APPROVED) return "is-active";
    if (status === REQUEST_STATUSES.PENDING) return "is-pending";
    if (status === REQUEST_STATUSES.REJECTED) return "rejected";
    return "";
  }

  const columns = [
    {
      key: "name",
      header: <FormattedMessage id="kpi-histoy.name" />,
      cell: (item) => item.ActionByModel?.DisplayName || "--",
      width: "20%",
    },
    {
      key: "action",
      header: <FormattedMessage id="kpi-histoy.action" />,
      cell: (item) =>
        item.Status === REQUEST_STATUSES.SUBMITTED ? (
          <span>
            <FormattedMessage id="common.update-kpi-value" />
            <FormattedMessage id="common.from" /> {data.Form?.OldValue}
            {getUnitOfMeasure(data.UnitOfMeasure)}
            <FormattedMessage id="common.to" /> {data.Form?.Value}
            {getUnitOfMeasure(data.UnitOfMeasure)}
          </span>
        ) : (
          `${getStatusKPIName(
            requestStatuses,
            item.Status?.toString(),
            locale
          )} (${isAr ? item.ArabicName : item.EnglishName})`
        ),
      width: "30%",
    },
    {
      key: "data",
      header: <FormattedMessage id="common.action-date" />,
      cell: (item) => formatDate(item.Modified),
      width: "15%",
    },
    {
      key: "comment",
      header: <FormattedMessage id="kpi-histoy.comment" />,
      cell: "Comments",
      width: "35%",
    },
  ];

  return (
    <div className="workflow-history">
      <div className="tb-cont">
        <div id="timeline_1">
          <ul className="list-unstyled multi-steps">
            {data?.RequestSteps.length > 0 ? (
              <>
                {data?.RequestSteps?.map((item, i) => (
                  <li
                    className={`${getStyle(item.Status)} ${locale}`}
                    key={item.ID}
                  >
                    {isAr ? item.ArabicName : item.EnglishName}
                  </li>
                ))}
              </>
            ) : null}
          </ul>
        </div>
        <Table
          compact
          columns={columns}
          data={data.RequestSteps}
          headerHasBackgroundColor
        />
      </div>
    </div>
  );
}

export default History;
